var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"address",staticClass:"form-control",attrs:{"name":_vm.inputName,"type":"text","placeholder":_vm.inputPlaceholder,"required":_vm.inputRequired,"id":_vm.inputId,"autocomplete":"off"},domProps:{"value":_vm.initialValue}})
}
var staticRenderFns = []

export { render, staticRenderFns }